import { UserBehaviorRisksAppBaseDataProvider } from './UserBehaviorRisksAppBaseDataProvider';
import { UserBehaviorRisksAppWebComponentSchema } from '../types';

export class UserBehaviorRisksAppNirvanaDataProvider extends UserBehaviorRisksAppBaseDataProvider {
  async getDataForView(): Promise<UserBehaviorRisksAppWebComponentSchema> {
    return {} as unknown as UserBehaviorRisksAppWebComponentSchema;
  }
}
